import axios from "axios";
const baseURL = process.env.VUE_APP_MYVLECAD_BASE_URL;

class AuthService {
  async loginUser(username, password) {
      console.log("loginUser");
      console.log("baseURL: " + baseURL);
      var response = {};

      var user = {};
      user.email = username;
      user.password = password;
      console.log("login url: " + baseURL+"/api/user/find.php");
      return await axios.post(baseURL+"/api/user/find.php", user)
      .then(response => {
          //console.log("loginUser response: " + JSON.stringify(response));
          return response.data;
      })
      .catch(error => {
          console.log("loginUser error: " + error);
          response.message = error;
          return error;
      });
  }

  async loginUserWP(username, password) {
    console.log("loginUser");
    console.log("baseURL: " + baseURL);
    var response = {};

    var user = {};
    user.email = username;
    console.log("login url: " + baseURL+"/api/user/findWP.php");
    return await axios.post(baseURL+"/api/user/findWP.php", user)
    .then(response => {
        //console.log("loginUser response: " + JSON.stringify(response));
        return response.data;
    })
    .catch(error => {
        console.log("loginUser error: " + error);
        response.message = error;
        return error;
    });
}

  register(username, password) {
      console.log("register");
      axios.post('', {user: username, password: password})
      .then(response => {
          return response.data;
      });
  }

  async getAUC(customerId, baseUrl) {
    console.log("getAUC");
    var response = {};
    console.log("getAUC url: " + baseUrl+"api/getAucByCustomerId/"+customerId);

    return await axios.get(baseUrl+"api/getAucByCustomerId/"+customerId)
    .then(response => {
        console.log("getAUC response: " + JSON.stringify(response));
        return response.data;
    })
    .catch(error => {
        console.log("getAUC error: " + error);
        response.message = error;
        return response;
    });
  }

  async getAUC2(cid) {
    console.log("getAUC");
    var response = {};
    var data = {};
    data.accountNumber = cid;
    console.log("getAUC url: " + baseURL+"/api/corsblocked/getAUC.php");
    return await axios.post(baseURL+"/api/corsblocked/getAUC.php", data)
    .then(response => {
        //console.log("getAUC response: " + JSON.stringify(response));
        return response.data;
    })
    .catch(error => {
        console.log("getAUC error: " + error);
        response.message = error;
        return response;
    });
  }

  async getFBInsights() {
    console.log("getFBInsights");
    var response = {};
    return await axios.get("https://vfb.vlecad.be/api/insights")
    .then(response => {
        //console.log("getFBInsights response: " + JSON.stringify(response));
        return response;
    })
    .catch(error => {
        console.log("getFBInsights error: " + error);
        response.message = error;
        return response;
    });
  }
}

export default new AuthService();

/*
export async function loginUser(username, password) {
    // Mock API Login
    if (username === 'admin' && password === 'password') {
      return { username: 'admin', token: 'mock-jwt-token' };
    }
    throw new Error('Invalid credentials');
  }
  
  export async function register(username, password) {
    // Mock API Registratie
    if (username && password) {
      return { username, token: 'mock-jwt-token' };
    }
    throw new Error('Registration failed');
  }
*/